import { useCallback } from 'react';
import { connect } from 'react-redux';
import { reduxForm } from 'redux-form';

import { useTranslation } from 'react-i18next';

import { user } from 'services';
import { Submit, ButtonContainer } from 'libs/ui';
import { StyledField, ErrorMsg, required, itn, iec, psrn, okpo } from 'libs/form';
import { LK } from './lk';

const LegalPersonFormForm = (props) => {
  const { t } = useTranslation();
  const { initialValues, handleSubmit, submitting, error } = props;

  const rightUpdate = user.haveRight('clients.update');

  const requiredName = useCallback(required(t), [t]);
  const requiredItn = useCallback(itn(t), []);
  const requiredIec = useCallback(iec(t), []);
  const requiredPsr = useCallback(psrn(t), []);
  const requiredOkpo = useCallback(okpo(t), []);

  return (
    <form onSubmit={handleSubmit}>
      <ErrorMsg theme="dark" message={error} />
      <StyledField validate={requiredName} type="text" label={t('grid.Наименование')} name="name" placeholder={t('grid.Компания')} />
      <StyledField validate={requiredItn} mask="9999 9999 9999" type="text" label="ИНН" name="itn" placeholder="" />
      <StyledField validate={requiredIec} mask="9999 9999 9" type="text" label="КПП" name="iec" placeholder="" />
      <StyledField validate={requiredPsr} mask="9999 9999 9999 9" type="text" label="ОГРН" name="psrn" placeholder="" />
      <StyledField validate={requiredOkpo} mask="9999 9999 99" type="text" label="ОКПО" name="okpo" placeholder="" />
      <StyledField type="text" label={t('form.Юр.адрес')} name="legal_address" placeholder={t('form.Адрес')} />
      <StyledField type="text" label={t('form.Почтовый адрес')} name="postal_address" placeholder={t('form.Адрес')} />
      {initialValues.id && <LK lk_login={initialValues.lk_login} />}
      {rightUpdate && (
        <ButtonContainer>
          <Submit disabled={submitting} />
        </ButtonContainer>
      )}
    </form>
  );
};

export const LegalPersonForm = reduxForm({
  form: 'LegalPersonForm',
})(LegalPersonFormForm);
